export default __webpack_public_path__ + "static/media/ttaConnectLogo.37d78231.svg";